import { Typography, useTheme } from '@mui/material';
import hexToRgba from 'hex-to-rgba';
import i18next from 'i18next';
import { memo, useCallback } from 'react';

import { MultiStoreDot } from './multi-store-dot';

interface MultiStoreHourChipProps {
  hour: string;
  // solo negli orari del giorno: il chip scelto è pieno; omesso nei chip «orari più vicini»
  isSelected?: boolean;
  // libero solo negli altri centri inclusi: puntino in alto a destra
  isElsewhereOnly?: boolean;
  onSelect: (hour: string) => void;
}

// Chip di un orario con la resa dell'HourPicker. Il bottone esterno, trasparente, dà
// un'area di tocco di almeno 48px senza cambiare la misura del chip.
export const MultiStoreHourChip = memo(function MultiStoreHourChip({
  hour,
  isSelected,
  isElsewhereOnly = false,
  onSelect,
}: MultiStoreHourChipProps): JSX.Element {
  const { palette } = useTheme();
  const isFilled = isSelected === true;

  const handleClick = useCallback(() => {
    onSelect(hour);
  }, [hour, onSelect]);

  return (
    <button
      type="button"
      className="multi-store-hour-target"
      aria-pressed={isSelected}
      aria-label={
        isElsewhereOnly
          ? `${hour}, ${i18next.t('pages.when.multi_store.elsewhere_only')}`
          : undefined
      }
      onClick={handleClick}
    >
      <span
        className="multi-store-hour"
        style={{
          backgroundColor: isFilled
            ? palette.primary.main
            : hexToRgba(palette.primary.main, palette.mode === 'dark' ? 0.3 : 0.12),
          color: isFilled ? palette.primary.contrastText : palette.text.primary,
        }}
      >
        <Typography variant="body2" component="span">
          {hour}
        </Typography>
        {isElsewhereOnly && (
          <MultiStoreDot isInverted={isFilled} className="multi-store-hour-dot" />
        )}
      </span>
    </button>
  );
});
